// TaskType -> bell-row config (icon, i18n text key, click-through route) for the five completed
// processes that raise a notification. ISIR maps two writer strings (import + parse) to one row.
//
// Keyed LOWERCASE and read only through getNotificationType(), which lowercases the incoming
// TaskType: the API returns each writer's stored casing (mostly PascalCase from the
// BackgroundTaskType enum, plus the lowercase 't2202generate'), and a plain object lookup is
// case-sensitive — a casing mismatch would silently render no row while the unread badge still
// showed a count.
//
// This map and the backend NotificationTaskTypes array are the two — and only two — places a new
// process gets wired (e.g. Statements/Transcripts later): add one row here, one entry there.
const notificationTypes = {
  t2202generate: {
    textKey: 'commonLabel.notifT2202GenerationCompleted',
    icon: 'credit_card',
    route: '/billing/reports-menu/t2202-form?tab=results',
  },
  rebuildrepeat: {
    textKey: 'commonLabel.notifRebuildRepeatCompleted',
    icon: 'settings',
    route: '/system-manager/rebuild/registration/rebuild-repeats?tab=results',
  },
  isirimport: {
    textKey: 'commonLabel.notifISIRImportCompleted',
    icon: 'build_circle',
    route: '/tools/import/financial-aid/isir-direct?tab=results',
  },
  parseisirdocument: {
    textKey: 'commonLabel.notifISIRImportCompleted',
    icon: 'build_circle',
    route: '/tools/import/financial-aid/isir-direct?tab=results',
  },
  initiatenscexport: {
    textKey: 'commonLabel.notifNSCExportCompleted',
    icon: 'build_circle',
    route: '/tools/export/financial-aid/nsc-export?tab=results',
  },
  packagingprocess: {
    textKey: 'commonLabel.notifPrioritizedPackagingCompleted',
    icon: 'account_balance',
    route: '/financial-aid/packaging/prioritized/package?tab=results',
  },
};

// Case-insensitive lookup — the single entry point callers use to resolve a row's config.
export const getNotificationType = (taskType) =>
  taskType ? notificationTypes[taskType.toLowerCase()] : undefined;

export default notificationTypes;
